import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ServerapiService } from '../serverapi.service';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from '../_services/masterservice.service';
import { SubscriptionService } from '../subscription/subscription.service';
import { OncocareDigitalService } from '../oncocaredigitalservice.service';
import { cncrDctrRegList } from '../common/cancer-doctor-registration/cancer-doctor-registration.component';
import { Configuration } from '../app.constants';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-common-registration',
  templateUrl: './common-registration.component.html',
  styleUrls: ['./common-registration.component.css']
})
export class CommonRegistrationComponent implements OnInit {
  getCourseMaterLevel: any;
  selectedCourseId: number[] = [];
  submitted = false;
  submittedAdd = false;
  disableFlag = true;
  countryId = '101';
  hcountryId = '101';
  countryList;
  countryLists;
  stateId = '';
  stateList;
  districtId = '';
  districtList;
  districtSubList;
  genderId = '';
  currentLoingUserId;
  patientId = null;
  personId = null;
  userType;
  stageId = '';
  siteId = '';
  subSiteId = '';
  subTypeId = '';
  lookingForId = '';
  isHavePatient = true;
  clinicList;
  registerType;
  cancerSubsite;
  lookingFor;
  stage;
  stageIds = '';
  treatmentActivityList = [];
  currentStep: number = 1;
  isPatientRegistrations: boolean = false;
  isHealthWorkers: boolean = false;
  isDoctors: boolean = false;
  cdr = new cncrDctrRegList();
  countryListForCancer;
  stateListForCancer;
  districtListForCancer;
  finalCountry;
  finalState;
  finalDistrictlist = [];
  cncrDctrRegDetailsList: cncrDctrRegList[] = [];
  spec = [];
  reason: any[] = [];
  specialities: Speciality[] = [];
  specialityEditList = [];
  sendingList = [];
  cancerDoctorSendingList = [];
  cdrListForRender;
  specialityListForRender;
  doctortype = 'I';
  newdoctorID;
  doctorTitle;
  emptyList = [];
  doctorFlg;
  viewListFlag = false;
  statesSelect;
  districtsSelect;
  units;
  treatmentActivity: string = 'SELF-HELP website for supportive care';
  selectedLabel: string = '';
  patientTypeId: string = '';
  subdistrictId: string = '';
  cancerSubsiteId: string = '';
  lookingForIds: string = '';
  patientStatus = 1;
  showOtpPopupForNormalAndCancerPatient: boolean = false;
  showOtpPopupForDoctor: boolean = false;
  showOtpPopupForHealthWorker:boolean=false;
  enteredOtp: string = '';
  correctOtp;
  showResendButton = false;
  countdown = 60;
  countdownInterval: any;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private serverAPI: ServerapiService,
    private toastr: ToastrService,
    private masterService: MasterService,
    private subscriptionService: SubscriptionService,
    private oncocareDigitalService: OncocareDigitalService,
    private configuration: Configuration,
    private spinner: NgxSpinnerService
  ) {
    this.cancerSubsite = [
      { id: 'Throat ', name: 'Throat' },
      { id: 'Breast', name: 'Breast' },
      { id: 'Kidney', name: 'Kidney' },
      { id: 'Prostate', name: 'Prostate' },
      { id: 'Bladder', name: 'Bladder' },
      { id: 'Uterus', name: 'Uterus' },
      { id: 'Brain', name: 'Brain' },
      { id: 'Cervix', name: 'Cervix' },
      { id: 'Ovary', name: 'Ovary' },
      { id: 'Bone/SoftTissue', name: 'Bone/SoftTissue' },
      { id: 'Mouth', name: 'Mouth' },
      { id: 'Intestine', name: 'Intestine' },
      { id: 'Blood', name: 'Blood' },
      { id: 'Lung', name: 'Lung' },
      { id: 'Liver-G.B.', name: 'Liver-G.B.' },
      { id: 'Pancreas', name: 'Pancreas' },
      { id: 'Colon-Recturn', name: 'Colon-Recturn' },
      { id: 'Other', name: 'Other' },
    ];
    this.lookingFor = [
      { id: 'Diagnosis', name: 'Diagnosis' },
      { id: 'Treatment Guidance', name: 'Treatment Guidance' },
      { id: 'Rehabilitation', name: 'Rehabilitation' },
      { id: 'Palliation', name: 'Palliation' },
      { id: 'Information as relative', name: 'Information as relative' }
    ];
    this.stage = [
      { id: 'Early', name: 'Early' },
      { id: 'Advance', name: 'Advance' },
    ];
  }

  /* THIS FOR COMMON USING ARRAYS */
  cancerRegisterList = [
    'SELF-HELP website for supportive care',
    'Personal assistance programme',
    'Online second opinion for treatment',
    'Find cancer expert in your district'
  ];
  normalRegisterList = [
    'self-screening',
    'tobacco-de-addiction',
    'cancer-awareness-talks'
  ];

  timeList = [
    { id: '1', name: '< 1 month' },
    { id: '2', name: '1-3 month' },
    { id: '3', name: '> 3 month' }
  ];

  referedList = [
    { id: '1', name: 'Local Doctor' },
    { id: '2', name: 'Self' },
  ];

  issueList = [
    { id: 1, name: 'Finance' },
    { id: 2, name: 'Distance and stay' },
    { id: 3, name: 'No knowledge about treatment or hospital' },
    { id: 4, name: 'Fear about treatment' },
    { id: 5, name: 'Cultural - Regional issues' },
    { id: 6, name: 'Alternative medicine' },
  ];

  patientTypeLabels = {
    '0': 'Cancer-Patient',
    '1': 'Normal-Patient',
    '2': 'Doctor',
    '3': 'Health-Worker'
  };

  ngOnInit() {
    document.documentElement.scrollTop = 0;
    this.personId = this.activeRoute.snapshot.paramMap.get('personId');
    this.patientId = this.activeRoute.snapshot.paramMap.get('patientId');
    this.currentLoingUserId = localStorage.getItem('currentLoingUserId');
    this.userType = localStorage.getItem('userType');
    this.getAllCountries();
    // this.showRegisterType(0,false)
    this.cdr.state = '';
    this.cdr.country = '101';
    this.cdr.district = '';
  }


  /*   THIS FOR NORMAL PATIENT AND CANCER PATIENT */
  patientRegistrationForm = this.fb.group({
    firstName: ['', Validators.required],
    middleName: [''],
    lastName: [''],
    dateOfBirth: [''],
    gender: ['', Validators.required],
    age: ['', Validators.required],
    mobileNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
    password: ['12345678', [Validators.required, Validators.minLength(8), Validators.maxLength(18)]],
    confirmPass: ['12345678', [Validators.required, Validators.minLength(8), Validators.maxLength(18)]],
    alternativeMobileNumberOne: [''],
    alternativeMobileNumberTwo: [''],
    emailId: [''],
    countryCode: ['+91', Validators.required],
    country: ['101', Validators.required],
    state: ['', Validators.required],
    district: ['', Validators.required],
    city: ['', Validators.required],
    pincode: [''],
    address: [''],
    aadharNumber: [''],
    stage: [''],
    site: [''],
    subSite: [''],
    subType: [''],
    lookingFor: [''],
    treatmentHistory: [''],
    patientType: ['1', Validators.required],
    treatmentStatus: [''],
    clinic: [''],
    patientStatus: [''],
    registerType: ['SELF-HELP website for supportive care', Validators.required],
    cancerSubsite: [''],
    lookingFors: [''],
    stages: [''],
    copunCode: [''],
    firstSign: [''],
    doctorConsult: [''],
    doctorReffered: [''],
    issues: [''],
    subdistrictId: ['']
  });


  /* THIS FOR DOCTOR */
  doctorForm = this.fb.group({
    designation: ['', Validators.required],
    doctorspec: [''],
    doctorclinictype: [''],
    hospitalName: [''],
    countryCode: ['+91'],
    registrationNo: [''],
    country: [],
    state: [''],
    district: [''],
    city: [''],
    clinicss: [''],
    address1: ['Defult'],
    pincode: ['0'],
    doctortype: [''],
    preScore: ['0'],
    postScore: ['0'],
    totalScore: ['0'],
    appointmentNo: [''],
    precticeAddress: ['', Validators.required],
    phone1: [''],
    name: [''],
    sex: [],
    copunCode: ['FREE'],
    password: [''],
    language: [''],
    courseMasterId: ['0'],
    subDistrictId: [0],
  });

  acceptTerms(event) {
    if (event.target.checked) {
      this.disableFlag = false;
    } else {
      this.disableFlag = true;
    }
  }

  get validMsg() {
    return this.patientRegistrationForm.controls;
  }

  get validMsgdoctorForm() {
    return this.doctorForm.controls;
  }

  // NORMAL PATIENT AND CANCER PATIENT
  onSubmit(flag:number) {
    if(flag == 1){
      this.submitted = true;
      if (this.patientRegistrationForm.invalid) {
        return;
      }
      this.sendOtp();
      this.showOtpPopupForNormalAndCancerPatient = true;
      this.showOtpPopupForDoctor = false;
      this.showOtpPopupForHealthWorker = false;
      this.startResendTimer();
    }else if(flag == 2){
       this.sendOtp();
      this.showOtpPopupForNormalAndCancerPatient = false;
      this.showOtpPopupForDoctor = true;
      this.showOtpPopupForHealthWorker = false;
      this.startResendTimer();
    }else{
       this.sendOtp();
      this.showOtpPopupForNormalAndCancerPatient = false;
      this.showOtpPopupForDoctor = false;
      this.showOtpPopupForHealthWorker = true;
      this.startResendTimer();
    }
  }

  startResendTimer() {
    this.showResendButton = false;
    this.countdown = 60;
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.showResendButton = true;
      }
    }, 1000);
  }

  resendOtp() {
    this.sendOtp();
    this.startResendTimer(); 
  }


sendOtp() {
  const mobileNo = this.patientRegistrationForm.value.mobileNumber;
  this.serverAPI.sendOtpCommon({ mobileNo: mobileNo }).subscribe(
    data => {
      this.toastr.success('OTP sent successfully!', 'Patient');
    },
    error => {
      this.toastr.error('Error sending OTP', 'Error');
    }
  );
}


  verifyOtp1() {
    this.serverAPI.getOtpVerify(Number(this.enteredOtp)).subscribe(
        data => {
            this.correctOtp=data;
            if (Number(this.enteredOtp) === this.correctOtp) {
            this.showOtpPopupForNormalAndCancerPatient = false;
            this.submit(); 
          } else {
            alert('Invalid OTP. Please try again.');
          }
      }
    );
  }

  verifyOtp2() {
    this.serverAPI.getOtpVerify(Number(this.enteredOtp)).subscribe(
        data => {
            this.correctOtp=data;
            if (Number(this.enteredOtp) === this.correctOtp) {
            this.showOtpPopupForDoctor = false;
            this.saveCancerDoctor(); 
            } else {  
              alert('Invalid OTP. Please try again.');
            }
      }
    );
  }

  verifyOtp3() {
      this.serverAPI.getOtpVerify(Number(this.enteredOtp)).subscribe(
      data => {
      this.correctOtp=data;
        if (Number(this.enteredOtp)=== this.correctOtp) {
        this.showOtpPopupForHealthWorker = false;
        this.saveDoctor(); 
      } else {
        alert('Invalid OTP. Please try again.');
      }
      }
    );
  }

  
  goPreviousUrl() {
      this.showOtpPopupForNormalAndCancerPatient = false;
      this.showOtpPopupForDoctor = false;
      this.showOtpPopupForHealthWorker = false;
  }

  submit() {
    this.submitted = true;
    if (this.patientRegistrationForm.invalid) {
      return;
    }
    this.patientRegister();
    this.patientRegistrationForm.reset();
    this.isMobileExists();
  }

  patientRegister() {
    this.disableFlag = true;
    const patientData = this.patientRegistrationForm.value;
    this.spinner.show();
    this.serverAPI.patientRegistration(patientData).subscribe(
      data => {
        this.toastr.success('Patient Registration Successfully!', 'Patient');
        this.resetForm();
        this.router.navigate(['/login']);
        this.spinner.hide();
      });
  }

  getAllCountries() {
    this.serverAPI.getCountries().subscribe(
      data => {
        this.countryList = data;
        this.patientRegistrationForm.controls.country.setValue('101');
        this.getStateByCountryId();
      });
  }

  getStateByCountryId() {
    this.serverAPI.getStates(this.patientRegistrationForm.controls.country.value).subscribe(
      data => {
        this.stateList = data;
        this.patientRegistrationForm.controls.state.setValue('12');
        this.getDistrictByStateId();
      });
  }

  getDistrictByStateId() {
    this.serverAPI.getDistricts(this.patientRegistrationForm.controls.state.value).subscribe(
      data => {
        this.districtList = data;
      });
  }


  getClinicByDistict = () => {
    this.oncocareDigitalService.getUnitsByDistrict(this.patientRegistrationForm.controls.district.value).subscribe(
      data => {
        this.clinicList = data;
        this.getSubDistrictByStateId();
      }
    );
  }

  getSubDistrictByStateId() {
    this.serverAPI.getSubDistricts(this.patientRegistrationForm.controls.district.value).subscribe(
      data => {
        this.districtSubList = data;
      });
  }


  showRegisterType(flag, isFirst) {
    this.CatagoryChangeForReset(flag);
    if (Number(flag) === 0) {
      this.patientRegistrationForm.controls.registerType.setValue("SELF-HELP website for supportive care")
      this.registerType = 'SELF-HELP website for supportive care'
      this.isPatientRegistrations = true;
      this.isHealthWorkers = false;
      this.isDoctors = false;
    }
    else if (Number(flag) === 1) {
      this.patientRegistrationForm.controls.registerType.setValue("self-screening")
      this.registerType = 'self-screening'
      this.isPatientRegistrations = true;
      this.isHealthWorkers = false;
      this.isDoctors = false;
    } else if (Number(flag) == 2) {
      this.isPatientRegistrations = false;
      this.isHealthWorkers = false;
      this.isDoctors = true;
      this.registerType = '';
    } else if (Number(flag) == 3) {
      this.isPatientRegistrations = false;
      this.isHealthWorkers = true;
      this.isDoctors = false;
      this.registerType = '';
    } else {
      this.treatmentActivityList = [''];
      this.isPatientRegistrations = false;
      this.isHealthWorkers = false;
      this.isDoctors = false;
      this.registerType = '';
    }
    if (isFirst && Number(flag) !== 1 && flag !== '') {
      this.nextStep();
    }
  }

  /*  getRegisterType(registerType) {
     this.registerType = registerType;
   } */



  resetForm() {
    this.patientId = null;
    this.personId = null;
    this.patientRegistrationForm.controls.countryCode.setValue('+91');
    this.countryId = '';
    this.stateId = '';
    this.districtId = '';
    this.genderId = '';
    this.stageId = '';
    this.siteId = '';
    this.subSiteId = '';
    this.subTypeId = '';
    this.lookingForId = '';
  }

  CatagoryChangeForReset(flag) {
    this.selectedLabel = this.patientTypeLabels[flag] || 'None';
    this.cancerSubsiteId = '';
    this.lookingForIds = '';
    this.reason = [];
    this.spec = [];
    this.doctorForm.controls.designation.setValue('');
    this.doctorForm.controls.hospitalName.setValue('');
    this.doctorForm.controls.appointmentNo.setValue('');
    this.doctorForm.controls.designation.setValue('');
    this.doctorForm.controls.clinicss.setValue('');
    this.doctorForm.controls.precticeAddress.setValue('');
    this.doctorForm.controls.language.setValue('');
    this.getCourseMaterLevel = [];
    this.resetform();
    this.partialEmpty();
  }

  checkPasswords(event) {
    const password = this.patientRegistrationForm.controls.password.value;
    const confirmPass = this.patientRegistrationForm.controls.confirmPass.value;
    if (password !== confirmPass && password.length > 0 && confirmPass.length > 0) {
      alert(' Password Not Match .');
      this.patientRegistrationForm.controls.confirmPass.setValue('');
    }
  }

  isMobileExists() {
    this.serverAPI.checkDuplicateMobileNumber(this.patientRegistrationForm.controls.mobileNumber.value).subscribe(
      data => {
        if (data === true) {
          this.toastr.error('Mobile number already register as UserName !', 'User Name');
          this.patientRegistrationForm.controls.mobileNumber.setValue('');
        }
      });
  }

  nextStep() {
    this.currentStep++;
  }

  prevStep() {
    this.currentStep--;
  }

  //THIS FROM DOCTOR REGISTRATIONS
  registerOptions = [
    { value: '1', label: 'Patient can find you from our website' },
    { value: '2', label: 'To train your staff for cancer support' },
    { value: '3', label: 'To establish patient support in your hospital' },
    { value: '4', label: 'To use our cancer-specific database' },
    { value: '5', label: 'All of the above' }
  ];
  specialitiess = [
    { value: 'Surgery', label: 'Surgery' },
    { value: 'Radiotherapy', label: 'Radiotherapy' },
    { value: 'Chemotherapy', label: 'Chemotherapy' },
    { value: 'Rehabilitation', label: 'Rehabilitation' },
    { value: 'Palliation & Pain', label: 'Palliation & Pain' },
    { value: 'All specialty cancer hospital', label: 'All specialty cancer hospital' }
  ];

  toggleCheckbox(value: any) {
    const selected = [...this.reason];
    const index = selected.indexOf(value);
    if (index > -1) {
      selected.splice(index, 1);
    } else {
      selected.push(value);
    }
    this.reason = selected;
  }

  toggleCheckboxspecialitiess(value: any) {
    const selecteds = [...this.spec];
    const index = selecteds.indexOf(value);
    if (index > -1) {
      selecteds.splice(index, 1);
    } else {
      selecteds.push(value);
    }
    this.spec = selecteds;
  }


  addCncrDctrDt() {
    this.submittedAdd = true;
    this.cdr.country = this.patientRegistrationForm.value.country;
    this.cdr.state = this.patientRegistrationForm.value.state;
    if (this.cdr.state && this.cdr.country && this.cdr.district && this.cdr.cncrTime && this.cdr.appointmentNo && this.cdr.address) {

      this.finalCountry = this.cdr.country;
      this.finalState = this.cdr.state;

      const cncrDt = new cncrDctrRegList();
      const c = this.countryList.find(o => Number(o.id) === Number(this.cdr.country));
      if (c) {
        cncrDt.countryname = c.name;
      }
      const s = this.stateList.find(p => Number(p.id) === Number(this.cdr.state));
      if (s) {
        cncrDt.stateName = s.name;
      }

      const d = this.districtList.find(q => Number(q.id) === Number(this.cdr.district));
      if (d) {
        cncrDt.districtName = d.name;
        const districtList = {
          'id': this.cdr.district,
          'name': d.name
        }
        this.finalDistrictlist.push(districtList);
      }
      cncrDt.country = this.cdr.country;
      cncrDt.state = this.cdr.state;
      cncrDt.district = this.cdr.district;
      cncrDt.cncrTime = this.cdr.cncrTime;
      cncrDt.appointmentNo = this.cdr.appointmentNo;
      cncrDt.name = this.cdr.name;
      cncrDt.address = this.cdr.address;
      cncrDt.address = this.cdr.address;

      this.cncrDctrRegDetailsList.push(cncrDt);
      this.partialEmpty();
    } else {
      this.toastr.warning('please fill the mandatory feilds');

    }

  }
  partialEmpty() {
    this.cdr.cncrTime = '';
    this.cdr.appointmentNo = '';
    this.cdr.district = '';
    this.cdr.address = '';
  }

  saveCancerDoctor() {
    this.submitted = true;
    if (this.patientRegistrationForm.value.firstName !== "" && this.patientRegistrationForm.value.gender !== ""
      && this.patientRegistrationForm.value.age !== "" && this.patientRegistrationForm.value.mobileNumber !== ""
      && this.patientRegistrationForm.value.confirmPass !== ""
    ) {
    } else {
      return;
    }


    for (const obj of this.spec) {
      const s = new Speciality();
      s.speciality = obj;
      this.specialities.push(s);
    }


    if (this.specialities.length <= 0) {
      return;
    }

    const tblSpeciality = new TblSpeciality();
    tblSpeciality.speciality = String(this.spec);
    tblSpeciality.countryId = this.finalCountry;
    tblSpeciality.name = this.patientRegistrationForm.value.firstName;
    tblSpeciality.stateId = this.finalState;
    tblSpeciality.mobileNo = this.patientRegistrationForm.value.mobileNumber;
    tblSpeciality.email = this.patientRegistrationForm.value.emailId;
    tblSpeciality.isActive = "1";


    const c = this.countryList.find(o => Number(o.id) === Number(this.cdr.country));
    if (c) {
      tblSpeciality.countryName = c.name;
    }
    const s = this.stateList.find(o => Number(o.id) === Number(this.cdr.state));
    if (s) {
      tblSpeciality.stateName = s.name;
    }

    this.sendingList.push(tblSpeciality);

    for (const ob of this.cncrDctrRegDetailsList) {
      const cancerDoctorReg = new CancerDoctorReg();
      cancerDoctorReg.districtId = (ob.district);
      cancerDoctorReg.districtName = String(ob.districtName);
      cancerDoctorReg.cncrTime = ob.cncrTime;
      cancerDoctorReg.appointmentNo = ob.appointmentNo;
      cancerDoctorReg.isActive = "1";
      cancerDoctorReg.isActive = "1";
      cancerDoctorReg.createdBy = '';
      cancerDoctorReg.createdDate = '';
      cancerDoctorReg.updatedBy = '';
      cancerDoctorReg.updatedBy = '';
      cancerDoctorReg.sp_id = '';
      cancerDoctorReg.address = ob.address;
      this.cancerDoctorSendingList.push(cancerDoctorReg);
    }

    this.spinner.show();
    const commonData = this.patientRegistrationForm.value;
    this.serverAPI.saveCancerDoctor(

      {
        'speciality': this.sendingList,
        'cncrDctrRegList': this.cancerDoctorSendingList,
        firstName: this.patientRegistrationForm.value.firstName,
        gender: this.patientRegistrationForm.value.gender,
        mobileNumber: this.patientRegistrationForm.value.mobileNumber,
        emailId: this.patientRegistrationForm.value.emailId,
        country: this.patientRegistrationForm.value.country,
        state: this.patientRegistrationForm.value.state,
        district: this.patientRegistrationForm.value.district,
        subdistrictId: this.patientRegistrationForm.value.subdistrictId,
        city: this.patientRegistrationForm.value.city,
        address: this.patientRegistrationForm.value.address,
        password: this.patientRegistrationForm.value.password,
        patientType: this.patientRegistrationForm.value.patientType,
        age:this.patientRegistrationForm.value.age
      }
    ).subscribe(
      cancerDoctorRegFormData => {
        this.toastr.success('Save Successfully!', 'Success!');
        this.resetform();
        this.cncrDctrRegDetailsList = [];
        this.cancerDoctorSendingList = [];
        this.sendingList = [];
        this.finalDistrictlist = [];
        this.router.navigate(['/login']);
        this.spinner.hide();
      }
    );
  }


  resetform() {
    this.spec = [];
    this.cdr.country = '';
    this.cdr.state = '';
    this.cdr.name = '';
    this.cdr.cncrTime = '';
    this.cdr.appointmentNo = '';
    this.cdr.district = '';
    this.cdr.address = '';
  }

  //THIS FOR HEALTH WORKER REGISTRATIONS
  async saveDoctor() {
      try {
        this.submitted = true;
        if (this.patientRegistrationForm.value.firstName !== "" && this.patientRegistrationForm.value.gender !== ""
          && this.patientRegistrationForm.value.age !== "" && this.patientRegistrationForm.value.mobileNumber !== ""
          && this.patientRegistrationForm.value.confirmPass !== ""
        ) {
        } else {
          return;
        }
        if (this.doctorForm.invalid) {
          return;
        }
        this.doctorForm.value.clinicss === '' ? this.doctorForm.controls.clinicss.setValue(this.emptyList)
          : this.doctorForm.controls.clinicss.setValue(this.doctorForm.value.clinicss);
        this.doctorForm.value.district = parseInt(this.doctorForm.value.district, 10);
        this.doctorForm.get('countryCode').enable();
        this.doctorForm.controls.doctortype.setValue(this.doctortype);
        this.doctorForm.controls.phone1.setValue(this.patientRegistrationForm.value.mobileNumber);
        this.doctorForm.controls.name.setValue(this.patientRegistrationForm.value.firstName);
        this.doctorForm.controls.sex.setValue(this.patientRegistrationForm.value.gender);
        this.doctorForm.controls.country.setValue(this.patientRegistrationForm.value.country);
        this.doctorForm.controls.state.setValue(this.patientRegistrationForm.value.state);
        this.doctorForm.controls.district.setValue(this.patientRegistrationForm.value.district);
        this.doctorForm.controls.city.setValue(this.patientRegistrationForm.value.city);
        this.doctorForm.controls.subDistrictId.setValue(this.patientRegistrationForm.value.subdistrictId);
        this.spinner.show();
        const doctorData = this.doctorForm.value;
        const courseMasterIds = this.selectedCourseId;
        const requestBody = {
          doctor: doctorData,
          password: this.patientRegistrationForm.value.confirmPass,
          courseMasterId: courseMasterIds
        };
        const newDoctorId = await this.serverAPI.postDoctor(requestBody).toPromise();
        this.newdoctorID = newDoctorId;

        this.submitted = false;
        this.doctorForm.reset();
        this.doctortype = this.activeRoute.snapshot.paramMap.get('type');
        if (this.doctortype === 'personal') {
          this.doctorTitle = 'Independent';
          this.doctortype = 'I';
        } else if (this.doctortype === 'clinic') {
          this.doctorTitle = 'Empanelled';
          this.doctortype = 'E';
        }
        this.toastr.success('Save Successfully!', 'Success!');
        this.router.navigate(['/login']);
        if (this.doctorFlg === 'personal') {
          this.viewListFlag = true;
        }

      } catch (error) {
        this.spinner.hide();
      } finally {
        this.spinner.hide();
      }
    }


    getAllCoursesByLanguage() {
      const selectedLanguage = this.doctorForm.get('language').value;

      this.serverAPI.getAllscourseMastersBylanguage(selectedLanguage).subscribe(
        data => {
          this.getCourseMaterLevel = data;
        }
      );
    }

    getSelectedCourseLevels(){
      this.selectedCourseId = this.doctorForm.get('courseMasterId').value;
    }
  }

export class Speciality {
  id: string;
  speciality: string;
  uniqueno: string;
}


export class TblSpeciality {
  id: string;
  speciality: string;
  name;
  mobileNo;
  email;
  countryId;
  stateId;
  isActive;
  reason;
  countryName: string;
  stateName: string;
}


export class CancerDoctorReg {
  id: string;
  cncrTime;
  appointmentNo;
  districtId;
  isActive;
  createdBy;
  createdDate;
  districtName: string;
  updatedBy;
  updatedDate;
  address;
  sp_id;
}

class Data {
  Speciality = [];
  cncrDctrRegList = [];
}